/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { registerLocaleData } from '@angular/common';
/* import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en-GB'; */

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(private analytics: AnalyticsService, private seoService: SeoService) {
   
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
    /* registerLocaleData(localeEn, 'en-GB');
    registerLocaleData(localeDe, 'de-DE'); */
  }
}
